module.exports = __webpack_public_path__ + "static/img/img-fa1.81e1930.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-fa1.png
// module id = Idxh
// module chunks = 0